/**
 * VENDOR MODULES
 */
import React from 'react';

import GridOdd from 'shared/components/outcomes/grids/GridOdd';

/***/
function Winners(props) {
  return (
    <div className="grid-item w-2/12 flex items-center justify-center">
      <GridOdd
        {...{
          ...props,
          class_names: ['pz_1'],
          market_type_group_id: 501
        }}
      />
    </div>
  );
}

export default Winners;

